<template>
  <IconBxsStar />
</template>
